import React from 'react';
import PropTypes from 'prop-types';

import { getStep } from '../../api';

import ProductRadio from '../../ProductRadio';

class Brackets extends React.PureComponent {
  state = {
    products: [],
    suggestedQuantity: 0,
  };

  componentDidMount() {
    const { rail_type, lengths } = this.props.values;

    const lengthKeys = rail_type === 'straight' ? Object.keys(lengths) : Object.keys(lengths).filter((key) => key.indexOf('L') === 0 && lengths[key] !== 0);
    const suggestedQuantity = lengthKeys.reduce((sum, key) => (
      sum + 2 + Math.floor(Math.max(0, (lengths[key] - 200 - 200) / 1000))
    ), 0);

    this.setState({ suggestedQuantity });
    this.props.setValue('brackets_quantity', suggestedQuantity);

    getStep({ ...this.props.values, step: this.props.step }, this.props.setLoading)
      .then(
        (res) => {
          this.setState({
            products: res,
          });
        },
        (error) => {
          console.log(error);
          this.props.setError('generic', error);
        }
      );

    setTimeout(() => this.validate(), 50);
  }

  componentWillUnmount() {
    this.props.setError('brackets');
  }

  validate() {
    const { values } = this.props;

    if (values.brackets_quantity !== 0 && !values.brackets) {
      this.props.setError('brackets', 'required');
    } else {
      this.props.setError('brackets');
    }
  }

  handleBracketChange = (name, value) => {
    this.updatePrice(value, this.props.values.brackets_quantity);

    setTimeout(() => this.validate(), 50);
  };

  handleQuantityChange = (e) => {
    const quantity = parseInt(e.target.value, 10) || 0;

    this.props.setValue('brackets_quantity', quantity);
    this.updatePrice(this.props.values.brackets, quantity);

    if (quantity === 0) {
      this.props.setValue('brackets', 0);
    }

    setTimeout(() => this.validate(), 50);
  };

  updatePrice(productId, quantity) {
    const product = this.state.products.find((product) => product.id === productId);

    if (product) {
      this.props.setValue('extras', {
        ...this.props.values.extras,
        brackets: product.price.raw * quantity,
      });  
    }
  }

  render() {
    const { instructions = {} } = window.MTMReact;
    const { brackets_quantity = 0 } = this.props.values;

    return (
      <React.Fragment>
        <div>
          <div className="mtm-instructions" dangerouslySetInnerHTML={{ __html: instructions && instructions.brackets }} />

          <label>
            Antal väggfästen
            <br />
            <small>Utifrån de angivna måtten rekommenderar vi minst {this.state.suggestedQuantity} stycken</small>
            <input type="number" min="0" name="brackets_quantity" value={brackets_quantity} onChange={this.handleQuantityChange} />
          </label>
        </div>

        {brackets_quantity !== 0 ? (
          <div id="mtm-end-caps" className="row small-up-2 medium-up-3 mediumlarge-up-4 large-up-3 xlarge-up-4 mtm-grid">
            {this.state.products.map((product) => (
              <ProductRadio
                key={product.id}
                fieldName="brackets"
                value={product.id}
                name={product.name}
                image={product.image.html}
                price={`${brackets_quantity} × ${product.price.string}`}
                onChange={this.handleBracketChange}
              />
            ))}
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

Brackets.propTypes = {
  step: PropTypes.number.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  setError: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
};

export default Brackets;





// WEBPACK FOOTER //
// ./src/Step/steps/Brackets.js